import type { FC } from 'react';

import Button from '@helsenorge/designsystem-react/components/Button';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';

interface DialogknappProps {
  buttonText: string;
}

export const Dialogknapp: FC<DialogknappProps> = ({ buttonText }) => {
  return (
    <>
      <Spacer size="l" />
      <Button htmlMarkup="a" href={`/auth/signin?Source=${encodeURIComponent(window.location.href)}`}>
        {buttonText}
      </Button>
    </>
  );
};
